import React, { useEffect, useRef, useState } from 'react';

import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import SectionContainer from '../../../Components/SectionContainer';
import PageHeading from '../../../Components/PageHaeding';
import { RootState, useAppSelector } from '../../../redux/store';
import InputField from '../../../Components/Input';
import AutocompleteSelect from '../../../Components/AutocompleteSelect';
import {
  getPermissionRoles,
  getPermissionRolesbyIdS,
} from '../../../redux/episodeSlice';
import CustomButton from '../../../Components/CustomButton';
import {
  debouncedEmailCheck,
  getDepartmentListForAddContact,
  getRoleList,
} from '../../../redux/commonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { COUNTRY_LIST } from '../../../assets/json/country_dial_info';
import { addCrewProductionSchema } from '../../../Utils/yupvalidations';
import { yupResolver } from '@hookform/resolvers/yup';
import { getUserDetailsWithPhone } from '../../../redux/StudioSlice';
import NoData from '../../../Components/Nodata';
import { notify } from '../../../Utils/toastify';
import SelectPhoneNumber from '../../../Components/SelectPhoneNumber';

import Loading from '../../../Components/Loading';
import WarningDialog from '../../../Components/WarningDialog';

import PageLayout from '../../../Containers/PageLayout';
import { addCrewMembers } from '../../../redux/dashboardSlice';
import ProductionRoles from './components/ProductionRoles';
import MUIAutoComplete from '../../../Components/MUIAutoComplete';
import AddJobTitleModal from '../../../Components/AddJobTitleModal';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { ANALYTICS_EVENTS } from '../../../helpers/analyticsEvents';

function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2, px: 0, pb: 0 }}>
          <div className="tabContainer">{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AddCrew = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { track } = useAnalytics();
  const [isDisabled, setIsDisabled] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [keyName, setKeyName] = useState<any>([]);
  const [checkEmailStatus, setCheckEmailStatus] = useState(false);
  const [isCrewOpen, setIsCrewOpen] = useState(false);

  const deptList = useAppSelector(
    (state: RootState) => state.common.departmentAddContact,
  );

  const {
    productionFormData: { clients },
    contacts,
  } = useSelector((state: any) => state.production);
  const { getrole } = useAppSelector((state: RootState) => state.episode);
  const { memberdetails } = useAppSelector(
    (state: RootState) => state.location,
  );

  const { loading } = useSelector((state: any) => state.location);
  const [isContactState, setIsContactState] = useState(
    () => memberdetails?.isContact && !memberdetails?.isCrew,
  );

  useEffect(() => {
    setIsContactState(memberdetails?.isContact && !memberdetails?.isCrew);
  }, [memberdetails]);
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    getValues,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(addCrewProductionSchema),
    mode: 'all',
    defaultValues: {
      countryCode: {
        name: 'United States',
        flag: '🇺🇸',
        code: 'US',
        dial_code: '+1',
      },
    },
  });

  const [isJobTitleModalOpen, setIsJobTitleModalOpen] = useState(false);
  const [jobTitleList, setJobTitleList] = useState<any>([]);
  const selectedDepartment = watch('departmentId')?._id;
  const fetchJobTitles = async () => {
    try {
      const data = roleList;
      setJobTitleList(
        data.filter(
          (item, index, self) =>
            index === self.findIndex(other => other._id === item._id),
        ),
      );
    } catch (error) {
      console.error('Error fetching job titles:', error);
    }
  };

  const { roleList } = useAppSelector((state: RootState) => state.common);

  useEffect(() => {
    getPermissionRoles();
    getDepartmentListForAddContact();
  }, []);

  useEffect(() => {
    if (selectedDepartment) {
      getRoleList(selectedDepartment);
    } else setJobTitleList([]);
  }, [selectedDepartment]);

  const location = useLocation();

  const { departMent, productionId, role } = location.state || {};

  useEffect(() => {
    track(ANALYTICS_EVENTS.ORDER_SETTINGS_ADD_CREW_PAGE_VIEW, {
      production_id: productionId ?? undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (departMent && getrole) {
      setValue('departmentId', departMent);
    }
    if (role && getrole) {
      const found = getrole.find(rol => rol?.roleName == role.label);
      console.log('found', found);
      setValue('staticRoleId', {
        label: found?.roleName,
        value: found?._id,
      });
      setValue('baseRole', found?.roleName);
      getPermissionRolesbyIdS(found?._id, (data: any) => {
        setAllRoles(data);
        const names: any = [];
        tabs.forEach(element => {
          const key: any = Object.keys(data[element])?.find(
            item =>
              item !== 'otherPermissions' && item !== 'permissionVisibility',
          );
          names.push(key);
        });
        setKeyName(names);
      });
    }
  }, [departMent, getrole]);

  const options = getrole.map(role => ({
    label: role.roleName,
    value: role._id,
  }));

  const addCrewTabLabels = ['production', 'episode', 'set', 'location'];
  const [valueTab, setValueTab] = React.useState(0);
  const [warningOpen, setWarningOpen] = useState(false);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueTab(newValue);
    track(ANALYTICS_EVENTS.ORDER_SETTINGS_ADD_CREW_TAB_SWITCHED, {
      tab: addCrewTabLabels[newValue] ?? String(newValue),
    });
  };
  const [allRoles, setAllRoles] = useState<any>({});
  const handleOpenWarning = () => {
    setWarningOpen(true);
  };

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout | null = null;
    return (...args: any[]) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedFetchUserDetails = debounce(
    (phoneNo: any, countryCode: any) => {
      dispatch(
        getUserDetailsWithPhone(
          {
            phoneNo: phoneNo,
            countryCode: countryCode?.dial_code,
            countryAbbreviation: countryCode?.code,
          },
          (data: any) => {
            if (
              data?.message ===
              "User doesn't exist. Please enter an existing mobile number."
            ) {
              setValue(`firstName`, '');
              setValue(`lastName`, '');
              setValue(`email`, '');
              setValue(`countryAbbreviation`, countryCode?.code);
              setValue(`countryCode`, countryCode);
              setValue(`country`, countryCode?.name);
              setValue(`profilePicture`, '');
              setIsDisabled(false);
              return;
            }

            if (data) {
              setValue(`firstName`, data.data.firstName || '');
              setValue(`lastName`, data.data.lastName || '');
              setValue(`phoneNo`, data.data.phoneNo || '');
              setValue(`email`, data.data.email || '');
              setValue(`countryAbbreviation`, countryCode?.code);
              setValue(`countryCode`, countryCode);
              setValue(`country`, countryCode?.name);
              setValue(`profilePicture`, data.data.profilePicture || '');
              setIsDisabled(true);

              trigger('firstName');
              trigger('lastName');
              trigger('email');
            }
          },
        ),
      );
    },
    500,
  );

  const handleNameChange = (index: number, name: string, e: any) => {
    const phoneNo: any = getValues('phoneNo');
    const countryCode: any = getValues('countryCode');

    if ((name === 'phoneNo' || name === 'countryCode') && phoneNo?.length > 4) {
      debouncedFetchUserDetails(phoneNo, countryCode);
    }
  };

  const handleBackSpace = (e: any, index: number, status?: boolean) => {
    if (
      (e.key === 'Backspace' ||
        e.key === 'Delete' ||
        (e.ctrlKey && e.key === 'x')) &&
      status
    ) {
      setValue(`firstName`, '');
      setValue(`lastName`, '');
      setValue(`email`, '');
      setIsDisabled(false);
    }
  };

  useEffect(() => {
    const inputType: any = document.querySelector('#client_input_phone');

    if (inputType) {
      inputType.addEventListener('keypress', (evt: any) => {
        if (evt.which === 8) {
          return;
        }
        if (evt.which < 48 || evt.which > 57) {
          evt.preventDefault();
        }
      });

      inputType.addEventListener('keydown', function (e: any) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
    }
  }, []);

  const handleKeyDown = (event: any) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      return;
    }
  };

  const tabs = [
    'productionPermissions',
    'episodePermissions',
    'setPermissions',
    'locationPermissions',
  ];

  const handleChangeCall = (
    status: boolean,
    label: string,
    name: any,
    key: any,
    type?: any,
  ) => {
    let updatedRoles = JSON.parse(JSON.stringify(allRoles));

    if (type) {
      updatedRoles = {
        ...updatedRoles,
        [label]: {
          ...updatedRoles[label],
          [type]: {
            ...updatedRoles[label][type],
            [name]: {
              ...updatedRoles[label][type][name],
              [key]: status,
            },
          },
        },
      };

      //  Dependency logic

      if (key === 'edit' && status === true) {
        if ('delete' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['delete'] = true;
        }
        if ('extend' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['extend'] = true;
        }
        updatedRoles[label][type][name]['view'] = true;
      }

      if (key === 'delete' && status === true) {
        if ('edit' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['edit'] = true;
        }
        updatedRoles[label][type][name]['view'] = true;
      }
      if (key === 'extend' && status === true) {
        if ('edit' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['edit'] = true;
        }
        if ('delete' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['delete'] = true;
        }
        updatedRoles[label][type][name]['view'] = true;
      }

      if (key === 'view' && status === false) {
        if ('edit' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['edit'] = false;
        }
        if ('delete' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['delete'] = false;
        }
        if ('extend' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['extend'] = false;
        }
      }
      if (key === 'edit' && status === false) {
        if ('delete' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['delete'] = false;
        }
        if ('extend' in updatedRoles[label][type][name]) {
          updatedRoles[label][type][name]['extend'] = false;
        }
      }
    } else {
      updatedRoles = {
        ...updatedRoles,
        [label]: {
          ...updatedRoles[label],
          [name]: {
            ...updatedRoles[label][name],
            [key]: status,
          },
        },
      };

      if (key === 'edit' && status === true) {
        if ('delete' in updatedRoles[label][name]) {
          updatedRoles[label][name]['delete'] = true;
        }
        if ('extend' in updatedRoles[label][name]) {
          updatedRoles[label][name]['extend'] = true;
        }
        updatedRoles[label][name]['view'] = true;
      }

      if (key === 'delete' && status === true) {
        if ('edit' in updatedRoles[label][name]) {
          updatedRoles[label][name]['edit'] = true;
        }

        updatedRoles[label][name]['view'] = true;
      }
      if (key === 'extend' && status === true) {
        if ('edit' in updatedRoles[label][name]) {
          updatedRoles[label][name]['edit'] = true;
        }
        if ('delete' in updatedRoles[label][name]) {
          updatedRoles[label][name]['delete'] = true;
        }
        updatedRoles[label][name]['view'] = true;
      }

      if (key === 'view' && status === false) {
        if ('edit' in updatedRoles[label][name]) {
          updatedRoles[label][name]['edit'] = false;
        }
        if ('delete' in updatedRoles[label][name]) {
          updatedRoles[label][name]['delete'] = false;
        }
        if ('extend' in updatedRoles[label][name]) {
          updatedRoles[label][name]['extend'] = false;
        }
      }
      if (key === 'edit' && status === false) {
        if ('delete' in updatedRoles[label][name]) {
          updatedRoles[label][name]['delete'] = false;
        }
        if ('extend' in updatedRoles[label][name]) {
          updatedRoles[label][name]['extend'] = false;
        }
      }

      const allOther = updatedRoles[label]['otherPermissions'];

      Object.keys(allOther).forEach((val: any) => {
        if (key == 'view' && status === true) {
          updatedRoles[label]['otherPermissions'][val][key] = true;
        }

        if (key === 'edit' && status === true) {
          if ('delete' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['edit'] = true;
          }
          if ('extend' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['extend'] = true;
          }
          updatedRoles[label]['otherPermissions'][val]['view'] = true;
          updatedRoles[label]['otherPermissions'][val][key] = true;
        }
        if (key === 'delete' && status === true) {
          if ('edit' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['edit'] = true;
          }
          updatedRoles[label]['otherPermissions'][val]['view'] = true;
          updatedRoles[label]['otherPermissions'][val][key] = true;
        }

        if (key === 'extend' && status === true) {
          if ('edit' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['edit'] = true;
          }
          if ('delete' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['delete'] = true;
          }
          updatedRoles[label]['otherPermissions'][val]['view'] = true;
          updatedRoles[label]['otherPermissions'][val][key] = true;
        }

        if (key === 'view' && status === false) {
          if ('edit' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['edit'] = false;
          }
          if ('delete' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['delete'] = false;
          }
          if ('extend' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['extend'] = false;
          }
          updatedRoles[label]['otherPermissions'][val][key] = false;
        }
        if (key === 'edit' && status === false) {
          if ('delete' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['delete'] = false;
          }
          if ('extend' in updatedRoles[label]['otherPermissions'][val]) {
            updatedRoles[label]['otherPermissions'][val]['extend'] = false;
          }
          updatedRoles[label]['otherPermissions'][val][key] = false;
        }
        if (key === 'delete' && status === false) {
          updatedRoles[label]['otherPermissions'][val][key] = false;
        }
        if (key === 'extend' && status === false) {
          updatedRoles[label]['otherPermissions'][val][key] = false;
        }
      });
    }

    setAllRoles(updatedRoles);
  };

  const handleChangeVisiblity = (
    checked: boolean,
    item: string,
    label: string,
    key: string,
  ) => {
    console.log(item, label, key, 'handleChangeVisiblity');

    let updatedRoles = { ...allRoles };
    updatedRoles = {
      ...updatedRoles,
      [label]: {
        ...updatedRoles[label],
        ['permissionVisibility']: {
          ...updatedRoles[label]['permissionVisibility'],
          [key]: !checked
            ? [
                ...updatedRoles[label]['permissionVisibility'][key].filter(
                  (i: string) => i !== item,
                ),
              ]
            : [...updatedRoles[label]['permissionVisibility'][key], item],
        },
      },
    };
    if (item === 'all' && checked) {
      updatedRoles[label]['permissionVisibility'][key] = [
        'all',
        'own',
        'department',
      ];
    }
    setAllRoles(updatedRoles);
    // if (key === 'chatAccess') {
    //   setAllRoles((prev: any) => {
    //     const updatedArray = checked
    //       ? { ...prev, [key]: true }
    //       : { ...prev, [key]: false };

    //     return updatedArray;
    //   });
    // } else {
    //   setAllRoles((prev: any) => {
    //     const updatedArray = checked
    //       ? [...prev[key], item]
    //       : prev[key].filter((i: string) => i !== item);

    //     return { ...prev, [key]: updatedArray };
    //   });
    // }
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { profileData } = useAppSelector((state: RootState) => state.common);
  const onSubmit = async (data: any) => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const {
      firstName,
      lastName,
      phoneNo,
      email,
      profilePicture,
      countryCode: { dial_code, name, code },
      // { dial_code, name, code },
      roleName: { roleName },
      orderLimit,
      departmentId,
      staticRoleId,
      baseRole,
    } = data;

    const isDuplicate: any = clients?.some(
      (client: any) =>
        client.phoneNo === data?.phoneNo &&
        client.countryCode?.dial_code === data?.countryCode?.dial_code &&
        client.countryCode?.code === data?.countryCode?.code &&
        client?.countryCode?.name === data?.countryCode?.name,
    );

    if (isDuplicate) {
      notify(
        'The entered phone number is already associated with clients',
        'error',
      );
      return;
    }
    if (phoneNo == profileData?.phoneNo) {
      setIsSubmitting(false);
      return notify('Unable to designate the owner as a contact', 'error');
    }
    console.log(staticRoleId, 'data');
    const selectedRoleId = roleList.find((role: any) => {
      if (role.roleName === roleName) {
        return role._id;
      }
    });

    const contactData = {
      firstName, //done
      lastName, //done
      phoneNo, //done
      email, //done
      country: name, //done
      countryCode: dial_code, //done
      countryAbbreviation: code, //done
      memberType: 'CREW_MEMBER', //done
      isContact: false,
      roleName, //done
      roleId: selectedRoleId?._id,
      orderLimit, //done
      departmentId: departmentId?._id, //done

      staticRoleId: staticRoleId?.value, //done
      productionPermissions: allRoles?.productionPermissions,
      episodePermissions: allRoles?.episodePermissions,
      setPermissions: allRoles?.setPermissions,
      locationPermissions: allRoles?.locationPermissions,
      chatAccess: true,
      entityType: 'productions',
      entityId: productionId,
    };

    addCrewMembers(
      contactData,
      () => {
        track(ANALYTICS_EVENTS.ORDER_SETTINGS_CREW_MEMBER_ADDED, {
          production_id: productionId ?? undefined,
        });
        setIsSubmitting(false);
        navigate(-1);
      },
      () => {
        setIsSubmitting(false);
      },
    );
  };

  return (
    <PageLayout>
      <div className="pageBody ">
        <PageHeading
          navigateUrl={-1}
          pageTitle={'Add Crew Member'}
          pageName={'Add Crew Member'}
          isNestedBreadcrum
        />

        {loading ? (
          <Loading type="div" height="full" />
        ) : (
          <div className="lg-inputs">
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
              <SectionContainer
                heading="Role Details"
                children={
                  <div className="formContainer">
                    <Grid container spacing={2}>
                      <Grid item md={4} xs={12}>
                        <InputField
                          id={'client_input_phone'}
                          label={'Mobile Number'}
                          name={`phoneNo`}
                          placeholder="Enter Mobile number"
                          type="number"
                          control={control}
                          phone
                          maxLength={14}
                          requiredField
                          error={!!errors['phoneNo']}
                          getOnChangeValues={(e: any) => {
                            handleNameChange(0, 'phoneNo', e);
                          }}
                          helperText={
                            !!errors['phoneNo']
                              ? errors['phoneNo']?.message
                              : ''
                          }
                          onKeyUp={(e: any) =>
                            handleBackSpace(e, 0, isDisabled)
                          }
                          onKeyDown={handleKeyDown}
                          startAdornment={
                            <div className="select_in_field">
                              <FormControl fullWidth className="customSelect">
                                <Controller
                                  name={`countryCode`}
                                  control={control}
                                  defaultValue={'+1'}
                                  render={({ field }) =>
                                    field && (
                                      <SelectPhoneNumber
                                        control={control}
                                        name="countryCode"
                                        labelText=""
                                        id={'countryCode'}
                                        keyName="dial_code"
                                        options={COUNTRY_LIST}
                                        setValue={setValue}
                                        clearIcon
                                        limit={10}
                                        onChangeMethod={(e: any) =>
                                          handleNameChange(0, 'countryCode', e)
                                        }
                                      />
                                    )
                                  }
                                />
                              </FormControl>
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <InputField
                          id={`attribute`}
                          label={'First Name'}
                          name={`firstName`}
                          placeholder="Enter first name"
                          type="text"
                          control={control}
                          getOnChangeValues={(e: any) =>
                            handleNameChange(0, 'firstName', e)
                          }
                          error={!!errors['firstName'] && !!errors['firstName']}
                          helperText={
                            !!errors['firstName']
                              ? errors['firstName']?.message
                              : ''
                          }
                          disabled={isDisabled}
                          requiredField
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <InputField
                          id={`attribute`}
                          label={'Last Name'}
                          name={`lastName`}
                          placeholder="Enter last name"
                          type="text"
                          control={control}
                          getOnChangeValues={(e: any) =>
                            handleNameChange(0, 'lastName', e)
                          }
                          error={!!errors['lastName'] && !!errors['lastName']}
                          helperText={
                            !!errors['lastName']
                              ? errors['lastName']?.message
                              : ''
                          }
                          disabled={isDisabled}
                          requiredField
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <InputField
                          id="attribute"
                          label="Email Address"
                          name="email"
                          placeholder="Enter email"
                          type="text"
                          control={control}
                          error={!!errors['email']}
                          getOnChangeValues={(e: any) => {
                            const email = e.target.value;
                            const emailRegex =
                              /^[\w-]+(?:\.[\w-]+)*@((?:[a-zA-Z]+\.)*[a-zA-Z][a-zA-Z-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$/;
                            if (emailRegex.test(email)) {
                              debouncedEmailCheck(email, (status: any) => {
                                if (status) {
                                  setCheckEmailStatus(true);
                                } else {
                                  setCheckEmailStatus(false);
                                }
                              });
                            }
                            handleNameChange(0, 'email', e);
                          }}
                          helperText={
                            errors['email'] ? errors['email']?.message : ''
                          }
                          disabled={isDisabled}
                          requiredField
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <AutocompleteSelect
                          id="Department"
                          name={`departmentId`}
                          control={control}
                          labelText="Select Department"
                          placeHolderText="Select Department"
                          options={deptList || []}
                          error={
                            !!errors['departmentId'] && !!errors['departmentId']
                          }
                          setValue={setValue}
                          onChange={(event, value) => {
                            setValue('departmentId', value);
                            setValue('roleName', null);
                          }}
                          helperText={
                            !!errors['departmentId']
                              ? errors['departmentId']?.message
                              : ''
                          }
                          disabled={departMent}
                          defaultValue={''}
                          labelKey="deptName"
                          requiredField
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <MUIAutoComplete
                          control={control}
                          name="roleName"
                          labelText="Select Job Title"
                          id="roleName"
                          keyName="roleName"
                          options={
                            selectedDepartment
                              ? [
                                  { roleName: 'Create New', isNew: true },
                                  ...roleList.map((i: any) => ({
                                    ...i,
                                    roleName: i?.roleName,
                                  })),
                                ]
                              : [{ roleName: 'Create New', isNew: true }]
                          }
                          setValue={setValue}
                          placeHolderText={
                            selectedDepartment
                              ? getValues('roleName')
                                ? ''
                                : 'Select Job Title'
                              : 'Select Department first'
                          }
                          addOptionText="Not in the List? Create New"
                          isScroll
                          fetchMoreOptions={fetchJobTitles}
                          hasMoreOptions={!!selectedDepartment}
                          disableSearch={!selectedDepartment}
                          disabled={!selectedDepartment}
                          onAdd={() => {
                            setIsJobTitleModalOpen(true);
                            setValue('roleName', '');
                          }}
                          fromAddCrewForm
                          requiredField
                          error={!!errors['roleName']}
                          helperText={
                            !!errors['roleName']
                              ? errors['roleName']?.message
                              : ''
                          }
                        />
                      </Grid>

                      <Grid item md={4} xs={12}>
                        <AutocompleteSelect
                          id="production"
                          labelText="Permissions"
                          placeHolderText="Select Permissions"
                          name="staticRoleId"
                          control={control}
                          options={options}
                          disabled={role}
                          onChange={(e: any, value: any) => {
                            if (value) {
                              setValue('staticRoleId', value);
                              setValue('baseRole', value.label);
                              getPermissionRolesbyIdS(
                                value.value,
                                (data: any) => {
                                  setAllRoles(data);
                                  const names: any = [];
                                  tabs.forEach(element => {
                                    const key: any = Object.keys(
                                      data[element],
                                    )?.find(
                                      item =>
                                        item !== 'otherPermissions' &&
                                        item !== 'permissionVisibility',
                                    );
                                    names.push(key);
                                  });
                                  setKeyName(names);
                                },
                              );
                            }
                          }}
                          requiredField
                        />
                      </Grid>
                    </Grid>
                  </div>
                }
              />

              <SectionContainer
                heading="Access Details"
                children={
                  <>
                    {getValues('staticRoleId') ? (
                      <div className="formContainer accessControl">
                        <Box sx={{ width: '100%' }} padding={0}>
                          <Box
                            sx={{ borderBottom: 0, borderColor: 'divider' }}
                            className="tabsContainer"
                          >
                            <Tabs
                              value={valueTab}
                              onChange={handleTabChange}
                              aria-label="basic tabs example"
                              variant="scrollable"
                              centered
                              scrollButtons={false}
                              allowScrollButtonsMobile
                            >
                              <Tab label="Production" {...a11yProps(0)} />
                              <Tab label="Episode" {...a11yProps(1)} />
                              <Tab label="Set" {...a11yProps(2)} />
                              <Tab label="Location" {...a11yProps(3)} />
                            </Tabs>
                          </Box>
                          <CustomTabPanel value={valueTab} index={0}>
                            <ProductionRoles
                              roles={allRoles?.productionPermissions}
                              name={keyName[0]}
                              visibility={allRoles?.documentVisibility}
                              roleDetails={allRoles}
                              handleChangeCall={handleChangeCall}
                              label={tabs[0]}
                              handleChangeVisiblity={handleChangeVisiblity}
                            />
                          </CustomTabPanel>
                          <CustomTabPanel value={valueTab} index={1}>
                            <ProductionRoles
                              roles={allRoles?.episodePermissions}
                              name={keyName[1]}
                              roleDetails={allRoles}
                              handleChangeCall={handleChangeCall}
                              label={tabs[1]}
                              handleChangeVisiblity={handleChangeVisiblity}
                            />
                          </CustomTabPanel>
                          <CustomTabPanel value={valueTab} index={2}>
                            <ProductionRoles
                              roles={allRoles?.setPermissions}
                              name={keyName[2]}
                              roleDetails={allRoles}
                              handleChangeCall={handleChangeCall}
                              label={tabs}
                              handleChangeVisiblity={handleChangeVisiblity}
                            />
                          </CustomTabPanel>
                          <CustomTabPanel value={valueTab} index={3}>
                            <ProductionRoles
                              roles={allRoles?.locationPermissions}
                              name={keyName[3]}
                              roleDetails={allRoles}
                              handleChangeCall={handleChangeCall}
                              label={tabs}
                              handleChangeVisiblity={handleChangeVisiblity}
                            />
                          </CustomTabPanel>

                          <Grid container spacing={2} className="mb-12">
                            <Grid item xs={12} md={4}>
                              <InputField
                                id="discount"
                                name="orderLimit"
                                label="Order Limit"
                                placeholder="Enter Order Limit"
                                type="text"
                                maxLength={7}
                                control={control}
                                error={!!errors['orderLimit']}
                                helperText={errors['orderLimit']?.message || ''}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                                inputProps={{
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                }}
                                onChange={e => {
                                  const numericValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    '',
                                  );

                                  e.target.value = numericValue;

                                  control.setValue('orderLimit', numericValue, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                  });
                                }}
                                onKeyDown={e => {
                                  const allowedKeys = [
                                    8, 9, 27, 13, 46, 37, 38, 39, 40, 35, 36,
                                  ];

                                  const isNumericKey =
                                    (e.keyCode >= 48 && e.keyCode <= 57) ||
                                    (e.keyCode >= 96 && e.keyCode <= 105);

                                  const isAllowedKey = allowedKeys.includes(
                                    e.keyCode,
                                  );

                                  if (
                                    e.shiftKey &&
                                    e.keyCode >= 48 &&
                                    e.keyCode <= 57
                                  ) {
                                    e.preventDefault();
                                    return;
                                  }

                                  if (!isNumericKey && !isAllowedKey) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            </Grid>
                          </Grid>

                          <div className="formButtons end">
                            <CustomButton
                              onClick={handleOpenWarning}
                              size="large"
                              variant="outlined"
                              text="Cancel"
                              width="auto"
                              type="button"
                              id="cancel"
                              showIcon={false}
                            />

                            <CustomButton
                              size="large"
                              variant="contained"
                              text={isSubmitting ? 'Saving...' : 'Add'}
                              width="auto"
                              type="submit"
                              id="drafted"
                              showIcon={false}
                              disabled={isSubmitting || !isValid}
                            />
                          </div>
                        </Box>
                      </div>
                    ) : (
                      <NoData heading="Please Select Permission." />
                    )}
                  </>
                }
              />
              <WarningDialog
                open={warningOpen}
                title={'Cancel Crew Member?'}
                description={'Are you sure you want to cancel the Crew Member?'}
                type="warning"
                handleClose={() => setWarningOpen(false)}
                onClick={() => {
                  setWarningOpen(false);
                  navigate(-1);
                }}
                cancelBtnText="Cancel"
                confirmBtnText="Yes, Sure"
                showIcon={false}
              />
            </form>
          </div>
        )}
        <AddJobTitleModal
          open={isJobTitleModalOpen}
          onClose={() => {
            setValue('roleName', '');
            setIsJobTitleModalOpen(false);
          }}
          departmentIds={selectedDepartment}
          onSuccess={newJobTitle => {
            if (newJobTitle) {
              setValue('roleName', { roleName: newJobTitle });
            }
            setIsJobTitleModalOpen(false);
            setIsCrewOpen(true);
          }}
        />
      </div>
    </PageLayout>
  );
};

export default AddCrew;
